import Typography from "@mui/material/Typography";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import PaidIcon from "@mui/icons-material/Paid";
import Button from "@mui/material/Button";
import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { LoadingList } from "./LoadingComponents";

export const FacultyPublications = ({ data }) => {
  const Publication = ({ publication }) => {
    return (
      <div className="publication">
        <div className="title">
          <span className="paper-title">{publication.title}. </span>
          <span className="venue">
            <i>{publication.venue} </i>
          </span>
          <span>{publication.year > 0 ? `(${publication.year})` : ""}</span>
        </div>
        <div className="coauthors">
          {publication.coauthors.map((item, index) => {
            return <span key={index}>{item.name}</span>;
          })}
        </div>
        <div className="tags">
          {publication.keywords.map((item, index) => {
            return (
              <Tag
                key={index}
                color="var(--light-blue)"
                style={{ cursor: "pointer" }}
              >
                {item.id}
              </Tag>
            );
          })}
        </div>
        <div className="action">
          {publication.num_citations != 0 && (
            <Button
              style={{
                backgroundColor: "white",
                color: "#b45f06",
                borderRadius: 10,
                height: 25,
                paddingLeft: 0,
                textAlign: "left",
                textTransform: "none",
                marginRight: "10px",
              }}
            >
              <FormatQuoteIcon />
              <Typography align={"left"} style={{ fontSize: 12 }}>
                {publication["num_citations"]}
              </Typography>
            </Button>
          )}
          {/* <FeedBackButton /> */}
        </div>
      </div>
    );
  };
  return (
    <div className="faculty-publications">
      <LoadingList
        data={data}
        rows={4}
        component={data?.map((item, index) => {
          return <Publication publication={item} key={index} />;
        })}
      />
    </div>
  );
};

export const FacultyPeers = ({ data }) => {
  const Peer = ({ peer }) => {
    const navigate = useNavigate();
    return (
      <div className="peer">
        <div className="avatar">
          <img src={peer.photo} alt="avatar" className="photo" />
        </div>
        <div className="info">
          <div
            onClick={() => {
              navigate(`/benchmarking/faculty/profile/${peer.id}`);
              window.location.reload();
            }}
          >
            <p className="name">{peer.name}</p>
          </div>
          <p className="inst-name">{peer.department.inst_name}</p>
          <p className="position">{peer.position}</p>
          <div className="tags">
            {peer.keywords.map((item, index) => {
              return (
                <Tag
                  key={index}
                  color="var(--light-blue)"
                  style={{ cursor: "pointer" }}
                >
                  {item.id}
                </Tag>
              );
            })}
          </div>
          {/* <FeedBackButton /> */}
        </div>
      </div>
    );
  };
  return (
    <div className="faculty-peers">
      <LoadingList
        data={data}
        avatar={true}
        rows={2}
        component={data?.map((item, index) => {
          return <Peer key={index} peer={item} />;
        })}
      />
    </div>
  );
};

export const FacultyAwards = ({ data }) => {
  const Award = ({ award }) => {
    return (
      <div className="publication">
        <div className="title">
          <span>
            <b>{award.award_title}. </b>
          </span>
          <span className="venue">
            <i>{award.program_title}</i>
          </span>
        </div>
        <div className="coauthors">
          <span>{award.principal_investigators}</span>
        </div>
        <div className="tags">
          {award.keywords.map((item, index) => {
            return (
              <Tag
                key={index}
                color="var(--light-blue)"
                style={{ cursor: "pointer" }}
              >
                {item.id}
              </Tag>
            );
          })}
        </div>
        <div className="action">
          {/* {award.amount_awarded != 0 && (
            <Button
              style={{
                backgroundColor: "white",
                color: "#b45f06",
                borderRadius: 10,
                height: 25,
                paddingLeft: 0,
                textAlign: "left",
                textTransform: "none",
                marginRight: "10px",
              }}
            >
              <PaidIcon />
              <Typography align={"left"} style={{ fontSize: 12 }}>
                {award.amount_awarded}
              </Typography>
            </Button>
          )} */}
          {/* <FeedBackButton /> */}
        </div>
      </div>
    );
  };
  return (
    <div className="faculty-publications">
      <LoadingList
        data={data}
        rows={3}
        component={data?.map((item, index) => {
          return <Award award={item} key={index} />;
        })}
      />
    </div>
  );
};

export const FacultyExperience = ({ data }) => {
  const Experience = ({ experience }) => {
    return (
      <div className="experience">
        <div className="photo">
          <img src={experience?.photo_url} alt="experience" />
        </div>

        <div className="experience-info">
          <p className="inst-name">{experience.inst_name}</p>
          <p>
            {experience.from} - {experience.to}
          </p>
          {/* <FeedBackButton /> */}
        </div>
      </div>
    );
  };
  return (
    <div className="faculty-experience">
      <LoadingList
        data={data}
        rows={2}
        avatar={true}
        component={data?.map((item, index) => {
          return <Experience experience={item} key={index} />;
        })}
      />
    </div>
  );
};
